import * as React from "react";
import { Box, Container, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";

export const ExternalLayout: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: "#fafafa",
        color: "#000",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "linear-gradient(135deg, #e8f5e9 0%, #e3f2fd 100%)",
      }}
    >
      <Box
        sx={{
          py: 2,
          px: 2,
          textAlign: "center",
          borderBottom: "1px solid #eee",
          background: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
        }}
      >
        <img
          src="/logo/logo-hubency-horizontal.svg"
          alt="Hubency Carebag Logo"
          style={{ height: 18, verticalAlign: "middle" }}
        />
        <Typography variant="h6">- Carebag</Typography>
      </Box>

      <Container maxWidth="lg" sx={{ flex: 1, py: 4 }}>
        <Outlet />
      </Container>

      <Box
        sx={{
          py: 2,
          textAlign: "center",
          borderTop: "1px solid #eee",
          fontSize: "0.85rem",
          color: "text.secondary",
        }}
      >
        © {new Date().getFullYear()} HUBENCY — Le Rimbaud, Hall A, 22 av. des
        Nations, CS 40063 Villepinte 95926 Goussainville Cedex — Carebag
      </Box>
    </Box>
  );
};
